


// import React, { useState, useEffect } from "react";
// import { FaUser, FaHeart, FaShoppingCart } from "react-icons/fa";
// import "./Header.css";
// import spinelle from "../Images/spinelle.avif";
// import { Link, useNavigate } from "react-router-dom";

// const Header = () => {
//   const [query, setQuery] = useState("");
//   const [showUserMenu, setShowUserMenu] = useState(false);
//   const [user, setUser] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const storedUser = JSON.parse(localStorage.getItem("user"));
//     setUser(storedUser);
//   }, []);

//   const handleLogout = () => {
//     localStorage.removeItem("user");
//     setUser(null);
//     navigate("/");
//   };

//   const handleSearch = (e) => {
//     if (e.key === "Enter") {
//       const id = query.trim().toLowerCase();
//       const section = document.getElementById(id);
//       if (section) {
//         section.scrollIntoView({ behavior: "smooth", block: "start" });
//         section.classList.add("highlight-category");
//         setTimeout(() => section.classList.remove("highlight-category"), 2000);
//       }
//     }
//   };

//   return (
//     <>
//       <div className="header">
//         <img src={spinelle} alt="Logo" className="header-logo" />

//         <input
//           type="text"
//           placeholder="Search for Rings, Necklaces, Earrings..."
//           className="header-search desktop-only"
//           value={query}
//           onChange={(e) => setQuery(e.target.value)}
//           onKeyDown={handleSearch}
//         />

//         <ul className="navbar-list1">
//           <Link to="/" style={{ textDecoration: "none", color: "black" }}>
//             <li className="navbar-item1"><span>Home</span></li>
//           </Link>
//           <li className="navbar-item1"><span>Collections</span></li>
//           <Link to="/our-story" style={{ textDecoration: "none", color: "black" }}>
//             <li className="navbar-item1"><span>About Us</span></li>
//           </Link>
//           <Link to="/contact" style={{ textDecoration: "none", color: "black" }}>
//             <li className="navbar-item1"><span>Contact Us</span></li>
//           </Link>
//         </ul>

//         <div className="header-icons">
//           <div
//             className="icon-wrapper"
//             onMouseEnter={() => setShowUserMenu(true)}
//             onMouseLeave={() => setShowUserMenu(false)}
//           >
//             <FaUser />
//             {showUserMenu && (
//               <div className="user-dropdown">
//                 {user ? (
//                   <>
//                     <p className="dropdown-name">{user.name}</p>
//                     <p className="dropdown-email">{user.email}</p>
//                     <hr className="dotted-line" />
//                     <p className="dropdown-section">Account</p>
//                     <button onClick={handleLogout} className="dropdown-btn logout-btn">Logout</button>
//                   </>
//                 ) : (
//                   <>
//                     <p className="dropdown-text">Experience the elegance of Spinelle. Access exclusive collections.</p>
//                     <div className="drop-bts me-2">
//                       <Link to="/signup" className="dropdown-btn">Sign Up</Link>
//                       <Link to="/login" className="dropdown-btn">Login</Link>
//                     </div>
//                   </>
//                 )}
//               </div>
//             )}
//           </div>

//           <div className="icon-wrapper"><FaHeart /></div>
//           <div className="icon-wrapper"><FaShoppingCart /></div>
//         </div>
//       </div>

//       {/* Mobile Search Bar */}
//       <div className="mobile-search mobile-only">
//         <input
//           type="text"
//           placeholder="Search for Rings, Necklaces, Earrings..."
//           value={query}
//           onChange={(e) => setQuery(e.target.value)}
//           onKeyDown={handleSearch}
//         />
//       </div>
//     </>
//   );
// };

// export default Header;


import React, { useState, useEffect } from "react";
import { FaUser, FaHeart, FaShoppingCart, FaBars, FaTimes } from "react-icons/fa";
import "./Header.css";
import spinelle from "../Images/spinelle.avif";
import { Link, useNavigate } from "react-router-dom";

const Header = () => {
  const [query, setQuery] = useState("");
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    setUser(storedUser);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    navigate("/");
  };

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      const id = query.trim().toLowerCase();
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
        section.classList.add("highlight-category");
        setTimeout(() => section.classList.remove("highlight-category"), 2000);
      }
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <>
      <div className="header">
        {/* Mobile Hamburger Icon */}
        <div className="hamburger-icon mobile-only" style={{fontSize:"16px"}} onClick={toggleSidebar}>
          <FaBars />
        </div>

        <img src={spinelle} alt="Logo" className="header-logo" />

        <input
          type="text"
          placeholder="Search for Rings, Necklaces, Earrings..."
          className="header-search desktop-only"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleSearch}
        />

        <ul className="navbar-list1">
          <Link to="/" style={{ textDecoration: "none", color: "black" }}>
            <li className="navbar-item1"><span>Home</span></li>
          </Link>
          <li className="navbar-item1"><span>Collections</span></li>
          <Link to="/our-story" style={{ textDecoration: "none", color: "black" }}>
            <li className="navbar-item1"><span>About Us</span></li>
          </Link>
          <Link to="/contact" style={{ textDecoration: "none", color: "black" }}>
            <li className="navbar-item1"><span>Contact Us</span></li>
          </Link>
        </ul>

        <div className="header-icons">
          <div
            className="icon-wrapper"
            onMouseEnter={() => setShowUserMenu(true)}
            onMouseLeave={() => setShowUserMenu(false)}
          >
            <FaUser />
            {showUserMenu && (
              <div className="user-dropdown">
                {user ? (
                  <>
                    <p className="dropdown-name">{user.name}</p>
                    <p className="dropdown-email">{user.email}</p>
                    <hr className="dotted-line" />
                   <Link to="/profile"> <p className="dropdown-section">Account</p></Link>
                    <button onClick={handleLogout} className="dropdown-btn logout-btn">Logout</button>
                  </>
                ) : (
                  <>
                    <p className="dropdown-text">Experience the elegance of Spinelle. Access exclusive collections.</p>
                    <div className="drop-bts me-2">
                      <Link to="/signup" className="dropdown-btn">Sign Up</Link>
                      <Link to="/login" className="dropdown-btn">Login</Link>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>

          <div className="icon-wrapper"><FaHeart /></div>
          <div className="icon-wrapper"> 
              <Link to="/cart" className="cart-link">
          <FaShoppingCart />
 
        </Link></div>
        </div>
      </div>

      {/* Mobile Search Bar */}
      <div className="mobile-search mobile-only">
        <input
          type="text"
          placeholder="Search for Rings, Necklaces, Earrings..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleSearch}
        />
      </div>

      {/* Mobile Sidebar */}
      {sidebarOpen && (
        <div className="mobile-sidebarr">
          <div className="sidebar-headerr">
           <div className="sidebar-headerr2">
            <span className="sidebar-logoo">Spinelle</span>
              <FaTimes className="close-iconn" onClick={toggleSidebar} />
              </div>
          </div>
          <ul className="sidebar-linkss">
            <li><Link to="/">Home</Link></li>
            <li><Link to="#">Rings</Link></li>
            <li><Link to="#">Earrings</Link></li>
            <li><Link to="#">Pendants</Link></li>
            <li><Link to="#">Kids Jewellery</Link></li>
            <li><Link to="#">Bracelets</Link></li>
            <li><Link to="/our-story">About Us</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
           {user ? (
  <div className="sidebar-user-card">
    <div className="user-info">
      <div className="user-avatar">
        {user.name?.charAt(0).toUpperCase()}
      </div>
      <div>
        <div className="user-name">{user.name}</div>
        <div className="user-email">{user.email}</div>
      </div>
    </div>
    <button className="logout-button" onClick={handleLogout}>
      Logout
    </button>
  </div>
) : (
  <div className="sidebar-login-card">
<p className="login-text">Experience elegance crafted just for you</p>

    <Link to="/login" className="login-button">Login / Signup</Link>
  </div>
)}

          </ul>
        </div>
      )}
    </>
  );
};

const getCartItemCount = () => {
  const cart = JSON.parse(localStorage.getItem('cart')) || [];
  return cart.length;
};

export default Header;
